$('.delivery-option__selected').click(function(e){
    e.stopPropagation();
    $('.selling-plan').slideToggle();
})

$(document).click(function(){
    $('.selling-plan').slideUp();
});

$('.plan-inp:checked').parent().parent().parent().addClass('plan-selected');

$('.plan-inp').change(function(){
    $('.plan-selector__item').removeClass('plan-selected');
    $('.product-text').removeClass('one-time-selected');
    $('.plan-inp:checked').parent().parent().parent().addClass('plan-selected');
    $('.one-time:checked').parent().parent().parent().parent().parent().parent().addClass('one-time-selected');
    var plan_taken = $(this).attr('data-plan');
    var btn_txt = $(this).attr('data-btn-text');
    $('.if-plan').attr('name', plan_taken);
    $('.addToCart').text(btn_txt);
});

$('.selling-plan__item').click(function(e){
    var myPlan = $(this).attr('value');
    var myPlan_txt = $(this).text();
    $('.delivery-option__selected').text(myPlan_txt);
    $('.if-plan').val(myPlan);
    $('.selling-plan').slideToggle();
})